import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { InputAdornment, TextField } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { ValTextAndNumber } from "../../../Validators/ValTextAndNumber";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { ValidarDatosFactura } from "../../Credito/FacturarCreditoCerrados/ValidaDatosFactura";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import { TextFieldCliente } from "../../Credito/FacturarCreditoCerrados/TextFieldCliente";


export const FacturacionJDF = ({
    folio,
    setLoader,
    loader,
    updateComentarios,
    // Inyectado por ModalSolicitudCreditoJDF (ver ModalSCScreens). Habilita
    // "Siguiente" tras registrar una unidad, sin cerrar el modal.
    habilitarSiguiente,
}) => {
    const [mostrar_registro, setMostrar_Regisrtro] = useState(false);
    const [estatus, setEstatus] = useState({});
    const [datos_pedido, setDatos_pedido] = useState({});
    const [financiamiento, setFinanciamiento] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [datos_informacion, setDatos_informacion] = useState({});
    const [datos_facturacion, setDatosFacturacion] = useState({
        comentarios: "",
        comentarioscredito: "",
        estado: "",
        tiempoestimado: "",
        tiempotranscurrido: "",
        factura: false,
        nota_abono: false,
        idequip: "",
        idsucursal: "",
        serie_fiscal: "",
        folio_fiscal: "",
        documento: "",
    });
    const [sucursales_cliente, setSucursales_cliente] = useState([]);
    const [selected, setselected] = useState(null);
    const [factura, setFactura] = useState({
        documento: "",
        extension: "",
    });
    const [notaabono, setNotaAbono] = useState({
        documento: "",
        extension: "",
    });
    const [documentosequipo, setDocumentosEQUIP] = useState([]);


  
    const onDatosFacturacion = (prop, value, sbool, smensaje) => {
        setDatosFacturacion({
            ...datos_facturacion,
            [prop]: value,
        });
    };

    const onImprimirArchivo = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerFactura?folio=${folio
                }&registro=${selected.registro}&iddocumento=${Number(iddocumento)}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.comentarios;
                const downloadLink = document.createElement("a");
                const fileName = `${result.documento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onGuardar = () => {
        var data = datos_facturacion;
        const validate = ValidarDatosFactura(
            data,
            factura,
            notaabono,
            folio,
            datos_pedido.financiera,
            datos_facturacion.factura,
            datos_facturacion.nota_abono,
            selected.registro
        );

        var mensaje = "";
        var valido = true;
        documentosequipo.forEach((element) => {
            if (
                element.documento === undefined ||
                element.documento === null ||
                element.documento === ""
            ) {
                mensaje =
                    mensaje +
                    "Pendiente de relacionar el numero de documento en equip para el registro con importe de <bold>" +
                    FormatMoney(element.totalpagar) +
                    "</bold><br/><br/>";
                valido = false;
            }
        });
        // if (
        //   documentosequipo === undefined ||
        //   documentosequipo === null ||
        //   documentosequipo.length === 0
        // ) {
        //   Swal.fire(
        //     "FACTURACION",
        //     "Favor de indicar los documentos registrados en EQUIP",
        //     "error"
        //   );
        //   return;
        // }
        if (valido === false) {
            Swal.fire("FACTURACION", mensaje, "error");
            return;
        }

        if (validate.isValid === false) {
            Swal.fire("FACTURACION", validate.mensaje, "error");
            return;
        }

        // validate.post.documentos = documentosequipo;

        setLoader({ ...loader, mostrar: true });
        request
            .post("ACJDF_Cargar_Factura", validate.post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                setDocumentosEQUIP([]);
                setDatosFacturacion([]);
                setSucursales_cliente([]);

                setselected(null);

                // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
                if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
                    habilitarSiguiente();

                await Swal.fire(
                    "FACTURACION",
                    "Factura Registrada con exito",
                    "success"
                );
                // history.push(
                //   "/Credito/ListadoFacturarCreditoOtorgado"
                // );
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`scjFacturacion/informacion_pedido?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setDatos_pedido(result.datos_pedido);
                setFinanciamiento(result.financiamiento);
                setUnidades(result.unidades);
                setDatos_informacion(result.informacion);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    }, []);
    const onActualizarArray = (value, element) => {
        var newarray = financiamiento.map((item) => {
            if (item.docto === element.docto) {
                item.documento = value;
            }
            return item;
        });
        setFinanciamiento(newarray);
    };

    const onBuscarFactura = (item) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `FacturarEquipo/informacion_pedido_unidad?folio=${folio
                }&registro=${Number(item.registro)}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setDatosFacturacion(result.datos_pedido);
                setSucursales_cliente(result.sucursales);
                setselected(item);
                setDocumentosEQUIP(result.documentos);
                setMostrar_Regisrtro(true);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    };
    const [updatedocumento, setupdatedocumento] = useState(null);

    const updateDocumento = (index, value) => {
        var newvalue = documentosequipo;
        newvalue[index].documento = value;
        newvalue = [...newvalue, { orden: 0, documento: "" }];
        setDocumentosEQUIP(newvalue);
        setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
    };
    const updateDocumentoFinanciamiento = (index, value) => {
        var newvalue = documentosequipo;
        newvalue[index].docto_financiamiento = value;
        newvalue = [...newvalue, { orden: 0, documento: "" }];
        setDocumentosEQUIP(newvalue);
        setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
    };

    useEffect(() => {
        if (updatedocumento !== null) {
            const registros = documentosequipo.length;
            setDocumentosEQUIP(
                documentosequipo.filter((aa, index) => index !== registros - 1)
            );
        }
    }, [updatedocumento]);

    const onEliminarDocumento = (orden, index) => {
        if (orden !== 0) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `FacturarEquipo/EliminarRegistro?folio=${folio}&orden=${Number(
                        orden
                    )}&registro=${Number(selected.registro)}`
                )
                .then(() => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Facturación de Equipo", "Registro eliminado", "success");
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("FACTURACION", JSON.stringify(error), "error");
                });
        }
        setDocumentosEQUIP(
            documentosequipo.filter((e, position) => position !== index)
        );
    };

    const onImprimirPedido = () => {
        setLoader({ ...loader, mostrar: true });
        const iddocumento = 25;
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerDocumentoPedido?folio=${folio}&iddocumento=${Number(
                    iddocumento
                )}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.documento;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
            });
    };

    const onParticionar = (registro) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `FacturarEquipo/Particionar?folio=${folio}&registro=${Number(registro)}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setDatos_pedido(result.datos_pedido);
                setFinanciamiento(result.financiamiento);
                setUnidades(result.unidades);
                setEstatus(result.informacion);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    };

    return (
        <div className="Facturar-equipo-timeline">
            {datos_informacion.habilitar === undefined ||
                datos_informacion.habilitar === null ||
                datos_informacion.habilitar === false ? (
                <div
                    className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-mhusa-content-comentarios-${estatus.icono}`}
                >
                    <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                        <CheckCircleIcon />
                    </div>
                    <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                        {datos_informacion.comentarios}
                    </div>
                </div>
            ) : (
                <div className="solicitud-credito-a-facturar">
                    <div className="solicitud-credito-datos-pedido scroll-4">
                        <TextField
                            label="Razon social|"
                            value={datos_pedido.razonsocial}
                            size="small"
                            color="success"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <BusinessIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="RFC"
                            value={datos_pedido.rfc}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <BusinessIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="Método de pago"
                            value={datos_pedido.metodopago}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReceiptIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="Forma de pago"
                            value={datos_pedido.formapago}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReceiptIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="Uso de CFDI"
                            value={datos_pedido.usocfdi}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReceiptIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="Tipo de relación"
                            value={datos_pedido.tiporel}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReceiptIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="Anticipos"
                            value={datos_pedido.anticipos}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReceiptIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="Folios de anticipos"
                            value={datos_pedido.foliosanticipos}
                            size="small"
                            color="success"
                            sx={{ mt: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ReceiptIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className="solicitud-credito-info-facturar scroll-4">
                        <div className="solicitud-credito-info-facturar-titulo-container">
                            <div className="header">Datos de factura</div>
                            <div
                                className={
                                    "solicitud-credito-info-facturar-titulo-container-boton-descargar"
                                }
                                onClick={() => onImprimirPedido()}
                            >
                                <CloudDownloadIcon />
                                <div>Descargar Pedido</div>
                            </div>
                        </div>
                        {/* Tabla para representar los equipos solicitados*/}
                        <div className="container-table-unidades">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr>
                                        <th>Cantidad</th>
                                        <th>Linea</th>
                                        <th>Modelo</th>
                                        {/* <th>Importe</th> */}
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unidades.map((item) => (
                                        <tr>
                                            <td>{item.cantidad}</td>
                                            <td>{item.linea}</td>
                                            <td>{item.modelo}</td>
                                            <td className="table-unidades-agregar-unidad">
                                                {item.cantidad > 1 && (
                                                    <AddCircleIcon onClick={() => onParticionar(item.registro)} />
                                                )}
                                            </td>
                                            <td>
                                                <ReceiptLongIcon onClick={() => onBuscarFactura(item)} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Tabla de los detalles del financiamiento*/}
                        <div className="container-table-financiamiento">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr>
                                        <th>Docto</th>
                                        <th>Vencimiento</th>
                                        <th>Importe</th>
                                        <th>Interes</th>
                                        <th>Total Pagar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {financiamiento.map((item) => (
                                        <tr>
                                            <td>{item.docto}</td>
                                            <td>{item.vencimiento}</td>
                                            <td>{FormatMoney(item.importefinanciar)}</td>
                                            <td>{FormatMoney(item.interes)}</td>
                                            <td>{FormatMoney(item.totalpagar)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/*FACTURAS */}
                        {selected !== undefined && selected !== null && (
                            <div className="solicitud-credito-factura">
                                <div className="solicitud-credito-factura-header">
                                    {/* {`${selected.modelo} (${FormatMoney(selected.importe)})`} */}
                                </div>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="SERIE FISCAL"
                                    className="col1"
                                    type="text"
                                    onChange={({ target }) => {
                                        ValTextAndNumber(
                                            "serie_fiscal",
                                            target.value,
                                            onDatosFacturacion,
                                            true,
                                            10
                                        );
                                    }}
                                    value={datos_facturacion.serie_fiscal}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ReceiptIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="FOLIO FISCAL"
                                    className="col2"
                                    type="text"
                                    onChange={({ target }) => {
                                        ValTextAndNumber(
                                            "folio_fiscal",
                                            target.value,
                                            onDatosFacturacion,
                                            true,
                                            10
                                        );
                                    }}
                                    value={datos_facturacion.folio_fiscal}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ReceiptIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="DOCUMENTO EQUIP"
                                    className="cel3"
                                    type="text"
                                    onChange={({ target }) => {
                                        ValOnlyNumber(
                                            "documento",
                                            target.value,
                                            onDatosFacturacion,
                                            true,
                                            10
                                        );
                                    }}
                                    value={datos_facturacion.documento}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ReceiptIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextFieldCliente
                                    array={sucursales_cliente}
                                    onDatosFacturacion={onDatosFacturacion}
                                    idequip={datos_facturacion.idequip}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="SUCURSAL"
                                    className="col5"
                                    type="text"
                                    value={datos_facturacion.sucursal}
                                    disabled={true}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <BusinessIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <div className="col8">
                                    <div className="label-facturacion">CARGAR FACTURA</div>
                                    <TextField
                                        // label="Cargar Factura"
                                        fullWidth
                                        size="small"
                                        type="file"
                                        onChange={({ target }) => GetDocumentpo(target, setFactura)}
                                    />
                                    {datos_facturacion.factura === true && (
                                        <CheckCircleIcon
                                            className="has_document"
                                            onClick={() =>
                                                onImprimirArchivo(
                                                    datos_pedido.financiera === "JDF" ? 71 : 28
                                                )
                                            }
                                        />
                                    )}
                                </div>
                                {datos_pedido.financiera === "JDF" && (
                                    <div className="col9">
                                        <div className="label-facturacion">CARGAR NOTA DE ABONO</div>
                                        <TextField
                                            // label="Cargar Nota de abono"
                                            fullWidth
                                            size="small"
                                            type="file"
                                            onChange={({ target }) =>
                                                GetDocumentpo(target, setNotaAbono)
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end"></InputAdornment>
                                                ),
                                            }}
                                        />
                                        {datos_facturacion.nota_abono === true && (
                                            <CheckCircleIcon
                                                className="has_document"
                                                onClick={() => onImprimirArchivo(78)}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {mostrar_registro === true && (
                            <div className="solicitud-credito-footer">
                                <div
                                    className="solicitud-credito-footer-guardar"
                                    onClick={() => {
                                        onGuardar();
                                    }}
                                >
                                    <CheckCircleIcon />
                                    <div>REGISTRAR</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};